<template>
  <v-app-bar color="primary">
    <div style="display: flex; flex-direction: row; align-items: center" :style="isMobile ? 'display: flex; width: 100%; margin: auto' : 'width: 75%; margin: auto'">
      <v-btn
        :icon="$route.path !== '/' ? 'mdi-arrow-left' : ''"
        :readonly="$route.path === '/'"
        :ripple="$route.path !== '/'"
        variant="text"
        @click="$router.go(-1)"
      />
      <img alt="logo" src="@/assets/logo-sem-nome.png" style="width: 50px; cursor: pointer; margin-right: 5px;" @click="$router.push('/')">
      <h3 style="cursor: pointer; font-weight: bold; overflow: auto !important;" @click="$router.push('/')">AF Secretaria</h3>

      <v-spacer />

      <v-btn v-if="!isMobile" class="text-none" text="Início" prepend-icon="mdi-home" style="margin-right: 10px" @click="$router.push('/')" />
      <v-btn v-if="!isMobile" class="text-none" text="Minha Senha" prepend-icon="mdi-ticket" style="margin-right: 10px" @click="$router.push('/validar-senha')" />
      <v-btn v-if="!isMobile && isLoggedIn" class="text-none" text="Painel de Controle" prepend-icon="mdi-monitor-dashboard" style="margin-right: 10px" @click="$router.push('/dashboard')" />

      <v-spacer />

      <v-btn color="yellow" v-if="!isMobile && isLoggedIn" class="text-none" text="Sair" prepend-icon="mdi-logout" style="margin-right: 10px" @click="logout" />
      <v-btn color="yellow" v-show="($route as any).name !== 'Login'" class="text-none" text="Login" prepend-icon="mdi-account" style="margin-right: 10px" v-if="!isLoggedIn && !isMobile" @click="$router.push('/login')" />
      <v-switch
        v-model="isDark"
        hide-details
        :color="isDark ? 'white' : 'yellow'"
        :thumb-color="isDark ? 'white' : 'yellow'"
        :base-color="isDark ? 'white' : 'yellow'"
        density="comfortable"
        inset
        @click="store.toggleTheme"
        :style="isMobile ? 'flex: 0 0 auto !important; margin-right: 10px' : ''"
      >
        <template #thumb>
          <v-icon size="18" :color="isDark ? 'white' : 'blue'" :icon="isDark ? 'mdi-moon-waxing-crescent' : 'mdi-white-balance-sunny'" />
        </template>
      </v-switch>
    </div>
  </v-app-bar>
</template>

<script lang="ts">
  import { useAppStore } from '@/stores/app';

  export default {
    name: 'AppBar',
    data: () => ({
      store: null
    }),
    computed: {
      isMobile() {
        return this.$vuetify.display.mobile;
      },
      isLoggedIn() {
        return this.store.getIsLoggedIn;
      },
      isDark() {
        return this.store.getTheme === 'dark';
      }
    },
    created() {
      this.store = useAppStore();
    },
    methods: {
      logout() {
        localStorage.removeItem('token');
        this.$router.push('/login');
        this.axios.defaults.headers.common.Authorization = '';
      }
    }
  }
</script>

<style scoped>

</style>
